import styled from 'styled-components'

const Radio = styled.div<{ $mainColor?: string }>`
  #checkbox-status {
    border-radius: 100%;
    transform: scale(1.45);
    display: none;
  }

  label {
    margin: 0;
    line-height: 1em;
    display: flex;
    color: grey;
    position: relative;
  }

  label::before {
    border: 1px solid grey;
    content: ' ';
    display: inline-block;
    margin-right: 5px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    transition: border 0.15s ease-in-out;
    border-color: ${({ $mainColor }) => $mainColor || 'var(--mainHighlight)'};
  }

  label::after {
    border: 0px solid var(--mainHighlight);
    content: ' ';
    background: transparent;
    display: inline-block;
    margin-right: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    left: 4px;
    top: 4px;
    transition: border 0.15s ease-in-out;
  }

  input:checked + label::after {
    background: ${({ $mainColor }) => $mainColor || 'var(--mainHighlight)'};
  }
`

export interface CheckboxStateProps {
  state: boolean
  mainColor?: string
}

export const CheckboxState = ({ state, mainColor }: CheckboxStateProps) => (
  <Radio $mainColor={mainColor} className="radio">
    <input type="radio" disabled id="checkbox-status" checked={state} readOnly />
    <label htmlFor="checkbox-status" />
  </Radio>
)
